const loaded_scripts = {};

function loadScript(script_url) {
    if (loaded_scripts[script_url] === void 0) {
        loaded_scripts[script_url] = new Promise((resolve, reject) => {
            const scriptTag = document.createElement('script');
            scriptTag.src = script_url;
            scriptTag.onload = resolve;
            scriptTag.onreadystatechange = resolve;
            scriptTag.onerror = reject;
            window.document.head.appendChild(scriptTag);
        });
    }
    return loaded_scripts[script_url];
}
export default loadScript;